/* eslint-disable */
import React, { useMemo, useState } from 'react';
// import ImgPoint from '../../../../../../assets/animation_point.gif';
import ImgPlus from '../../../../../../assets/plus.png';
import ImgTipsPerson from '../../../../../../assets/tips-person.png';
// import { Tabs } from 'antd';
import { useStore } from '../../../../store';
import { useParams } from 'react-router-dom';
import { usePlayFlag } from '../../components/TopicScroll';
import AnswerCover from '../../components/AnswerCover';
import pwd_type_3_1 from '../../../../../../assets/2025/topic900/pwd_type_3_1.png';
import pwd_type_3_3 from '../../../../../../assets/2025/topic900/pwd_type_3_3.png';
import pwd_type_3_4 from '../../../../../../assets/2025/topic900/pwd_type_3_4.png';
import elePerson_2_1 from '../../../../../../assets/2025/topic900/elePerson_2_1.png';
import elePerson_2_2 from '../../../../../../assets/2025/topic900/elePerson_2_2.png';
import elePerson_2_3 from '../../../../../../assets/2025/topic900/elePerson_2_3.png';
import elePerson_2_4 from '../../../../../../assets/2025/topic900/elePerson_2_4.png';
import ImgPoint from '../../../../../../assets/2025/arrow.gif';
import { useUpdateComponentState } from '../../../hooks';
// const { TabPane } = Tabs;

interface ISection2Props {
  settings: any;
}

const Section2: React.FunctionComponent<ISection2Props> = ({ settings }) => {
  const ID = '3';
  // const videoRef = React.useRef() as React.MutableRefObject<HTMLVideoElement>;
  const videoContainerRef =
    React.useRef() as React.MutableRefObject<HTMLDivElement>;
  const playVideoFlag = usePlayFlag(
    videoContainerRef.current as HTMLElement,
    '.course-body'
  );
  const paragraphsSettings = useMemo(
    () => settings?.paragraphs[2],
    [settings?.paragraphs]
  );
  // React.useEffect(() => {
  //   if (playVideoFlag) {
  //     videoRef.current.play();
  //   }
  // }, [playVideoFlag]);

  const ap_videoRef =
    React.useRef() as React.MutableRefObject<HTMLVideoElement>;
  const ap_videoContainerRef =
    React.useRef() as React.MutableRefObject<HTMLDivElement>;
  const param = useParams();
  const p_course = param.course || '';
  const p_topic = param['*'] || 'welcome';
  const [state, setState] = React.useState({
    conversation: 0,
    animationPassword: false,
    coveredAnswer: 6,
  });
  const { updateParagraphState, language } = useStore();


  const showAnimationPassword = () => {
    setState({
      ...state,
      animationPassword: true,
    });
    ap_videoRef.current.play();
  };

  //视频播放
  const video_3_1_videoRef =React.useRef() as React.MutableRefObject<HTMLVideoElement>;
  const video_3_2_videoRef =React.useRef() as React.MutableRefObject<HTMLVideoElement>;

  const [video_topic3, setVideo_topic3] = React.useState<any>({
    playStatus:[false,false],
    index:0,
  });
  const updateComponentState = useUpdateComponentState()
  const video_3_1_play = () => {
    const newItems = [...video_topic3.playStatus];
    newItems[0] = true;
    setVideo_topic3({
      playStatus:newItems,
      index:1,
    });
    video_3_1_videoRef.current.play();
  };
  const video_3_2_play = () => {
    const newItems = [...video_topic3.playStatus];
    newItems[1] = true;
    setVideo_topic3({
      playStatus:newItems,
      index:2,
    });
    video_3_2_videoRef.current.play();
  };

  React.useEffect(() => {
    // if (video_topic3.index===2 && state.animationPassword) {
    //   updateParagraphState(p_course, p_topic, ID, 'completed', []);
    // }
    if(state.animationPassword){
      updateComponentState(p_course, p_topic, ID,'2025-topic900-section2-1')
    }
    if(video_topic3.index===2){
      updateComponentState(p_course, p_topic, ID,'2025-topic900-section2-2')
    }
  }, [
    p_course,
    p_topic,
    video_topic3.index,
    state.animationPassword,
    updateParagraphState,
  ]);

  // @ts-ignore
  return (
    <div className="topic-section-2">
      <i className="back_piece"></i>
      <div className="padding_box" style={{background: "#F3F9FF",paddingBottom:"1rem"}}>
        <div className="header_box"  id="2025-topic900-section2-1">
          <h1 className="header">{paragraphsSettings?.l47T}</h1>
        </div>
        <p
          style={{fontWeight:'500'}}
          className="content"
          dangerouslySetInnerHTML={{
            __html: paragraphsSettings?.l48,
          }}
        />
        <div className="flex_c">
          <div
            ref={ap_videoContainerRef}
            className="password-section video-container"
            onClick={showAnimationPassword}
          >
            <i className="video_people"></i>
            <img
              className={`point ${state.animationPassword ? 'hide' : ''}`}
              src={ImgPoint}
              alt=""
            />
            <video
              style={{
                position: 'relative',
              }}
              key={language}
              ref={ap_videoRef}
              width="100%"
              controls={false}
              autoPlay={false}
            >
              <source
                src={
                  language === 'tc'
                    ? '/videos/2025/animationpassword.mp4'
                    :(language === 'sc' ? '/videos/2025/animationpassword-sc.mp4':'/videos/2025/animationpassword-en.mp4')
                }
                type="video/mp4"
              />
              Your browser does not support HTML video.
            </video>
          </div>
        </div>
        <div className="flex_c">
          <div className="topic_box_title">
            <i className="video_people"></i>
            <div className="text"
                 dangerouslySetInnerHTML={{
                   __html: paragraphsSettings?.l50,
                 }}
            />
            <div className="right_box">{paragraphsSettings?.l51}<i className="icon"></i></div>
          </div>
        </div>
        <div className="flex_c">
          <div id="2025-topic900-section2-2" className="topic_content_box">
            <div className="left_box">
              <p className="title_t">{paragraphsSettings?.l53}</p>
              <div className="video-container3" onClick={video_3_1_play}>
                <img
                  className={`point ${(video_topic3.index===0 && video_topic3.playStatus[0]===false) ? '' : 'hide'}`}
                  src={ImgPoint}
                  alt=""
                />
                <video
                  ref={video_3_1_videoRef}
                  width="100%"
                  controls={false}
                  autoPlay={false}
                >
                  <source
                    src={
                      language === 'cn'
                        ? '/videos/2025/pwd_tips_l.mp4'
                        : '/videos/2025/pwd_tips_l.mp4'
                    }
                    type="video/mp4"
                  />
                  Your browser does not support HTML video.
                </video>
              </div>
            </div>
            <div className="right_box">
              <p className="title_t">{paragraphsSettings?.l59}</p>
              <div className="video-container3" onClick={video_3_2_play}>
                <img
                  className={`point ${(video_topic3.index===1 && video_topic3.playStatus[1]===false) ? '' : 'hide'}`}
                  src={ImgPoint}
                  alt=""
                />
                <video
                  ref={video_3_2_videoRef}
                  width="100%"
                  controls={false}
                  autoPlay={false}
                >
                  <source
                    src={
                      language === 'cn'
                        ? '/videos/2025/pwd_tips_l.mp4'
                        : '/videos/2025/pwd_tips_r.mp4'
                    }
                    type="video/mp4"
                  />
                  Your browser does not support HTML video.
                </video>
              </div>
            </div>
          </div>
        </div>
        </div>

      </div>
      );
      };
      export default Section2;
